/**
 * Samita ロック用属性が付いたカードで、ファセット AJAX 直後や Samita の再描画後も
 * 価格が一瞬見えないよう DOM 上で同期・追従する。
 * （Liquid と metafield のズレがある場合のフェイルセーフ）
 */
(function () {
  var ATTR_HIDE_ALL = {
    samita_pass_p_all: true,
    samita_pass_c_all: true,
    samita_all_p: true,
    samita_manual_p_all: true,
    samita_manual_c_all: true,
    samita_sec_p_all: true,
  };

  var ATTR_HIDE_PRICE = {
    samita_pass_p_price: true,
    samita_pass_c_price: true,
    samita_all_p_price: true,
    samita_manual_p_price: true,
    samita_manual_c_price: true,
    samita_sec_p_price: true,
  };

  var PRICE_RELATED =
    '.price, .price-item, .price__container, .price__regular, .price__sale, volume-pricing, .card__information-volume-pricing-note';

  function getLockMode(el) {
    var hideAll = false;
    var hidePrice = false;
    if (!el || !el.attributes) return { hideAll: false, hidePrice: false };

    for (var i = 0; i < el.attributes.length; i++) {
      var n = el.attributes[i].name;
      if (ATTR_HIDE_ALL[n]) hideAll = true;
      if (ATTR_HIDE_PRICE[n]) hidePrice = true;
    }
    return { hideAll: hideAll, hidePrice: hidePrice };
  }

  function hideUnderWrapper(wrapper) {
    var mode = getLockMode(wrapper);
    if (!mode.hideAll && !mode.hidePrice) return;

    if (mode.hideAll) {
      wrapper.style.setProperty('display', 'none', 'important');
      return;
    }

    wrapper.querySelectorAll(PRICE_RELATED).forEach(function (node) {
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.setAttribute('aria-hidden', 'true');
    });
  }

  function apply(root) {
    var container = root || document.getElementById('ProductGridContainer');
    if (!container) return;

    var grid = container.querySelector('#product-grid') || container.querySelector('ul.product-grid');
    if (!grid) return;

    var wrappers = grid.querySelectorAll('.card-wrapper.product-card-wrapper, .card-wrapper');
    for (var w = 0; w < wrappers.length; w++) {
      hideUnderWrapper(wrappers[w]);
    }
  }

  var mo = null;
  var debounceTimer = null;

  function scheduleApply(container) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      apply(container);
    }, 60);
  }

  function ensureObserver() {
    var pg = document.getElementById('ProductGridContainer');
    if (!pg || mo) return;

    mo = new MutationObserver(function () {
      scheduleApply(pg);
    });
    mo.observe(pg, { childList: true, subtree: true, attributes: true });
  }

  window.samitaApplyFacetGridPriceLock = function (root) {
    apply(root);
    ensureObserver();
  };

  document.addEventListener('DOMContentLoaded', function () {
    apply();
    ensureObserver();
  });
})();
